import { render } from "./PersonalizedPopupTemplate1.vue?vue&type=template&id=c0d8219c"
import script from "./PersonalizedPopupTemplate1.vue?vue&type=script&lang=js"
export * from "./PersonalizedPopupTemplate1.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__